const updates = [
  { date: '2026.07.30', tag: '上新', title: '《星河之约》第28集全网首发上线，高清完整版免费观看' },
  { date: '2026.07.28', tag: '热门', title: '院线大片《暗夜追击》HD高清版已更新，口碑爆棚动作巨制' },
  { date: '2026.07.26', tag: '剧集', title: '《长安旧事》全40集完结，一口气追完古装权谋大戏' },
  { date: '2026.07.24', tag: '综艺', title: '《欢乐星期天》最新一期笑点密集，嘉宾阵容再度升级' },
  { date: '2026.07.22', tag: '动漫', title: '热门国漫《山海传说》第三季定档，官方预告片抢先看' },
  { date: '2026.07.20', tag: '上线', title: '平台片源库突破10万+，新增海外热门影视专区' },
  { date: '2026.07.18', tag: '优化', title: '播放引擎全面升级，4K画质下缓冲速度提升40%' },
  { date: '2026.07.15', tag: '电影', title: '暑期档热门影片《极速风暴》高清版登陆，赛车题材燃爆夏日' },
];

const tagColors: Record<string, string> = {
  '上新': 'bg-primary-100 text-primary-700',
  '热门': 'bg-accent-100 text-accent-700',
  '剧集': 'bg-secondary-100 text-secondary-700',
  '综艺': 'bg-primary-100 text-primary-700',
  '动漫': 'bg-accent-100 text-accent-700',
  '上线': 'bg-secondary-100 text-secondary-700',
  '优化': 'bg-secondary-100 text-secondary-700',
  '电影': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">最新动态</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">片源更新与平台动态实时追踪</p>

        <div className="relative pl-8 border-l-2 border-background-200">
          {updates.map((item, i) => (
            <div key={i} className="relative pb-8 last:pb-0">
              <div className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-wrap items-center gap-2 mb-2">
                <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.date}</span>
                <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-background-100 text-foreground-600'}`}>
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}